module.exports = __webpack_public_path__ + "img/avatar0.2fe3d099.png";